import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseComponent} from '../BaseComponent';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent extends BaseComponent implements OnInit {

  displayedColumns = ['position', 'name', 'weight', 'symbol'];

  constructor(route: ActivatedRoute, router: Router) {
    super(route, router);
  }

  async ngOnInit() { }

  onFileComplete($event: string) {

  }
}

